<template>
  <v-container>
    <v-row class="text-center">
      <v-col class="" cols="12">
        <h1 style="font-size: 76px !important; line-height: normal;" class="font-weight-light mt-4">
          TAŞÇI SİGORTA'ya 
          <br>
          HOŞ GELDİNİZ
        </h1>

        <p style="font-size: 20px !important;" class="font-weight-regular mt-10">
          Sigortacılıkta 28. yıl
        </p>
      </v-col>

      <v-col
        class="d-flex justify-center mb-8"
        cols="12"
      >
        <div class="mb-10">
          <v-img
            alt="Tasci Sigorta Logo"
            class="shrink"
            src="../assets/family_sunset.png"
            transition="scale-transition"
            max-width="940"
          />
        </div>
      </v-col>

      <v-col
        class="mt-8 mb-4"
        cols="12"
      >
        <div class="d-flex justify-center">
          <v-col class="" cols="6">
            <h1 class="display-3 font-weight mb-10 float-left">
              Hizmetlerimiz
            </h1>
            <p style="line-height: 2;" class="text-justify float-left">
              Sağlık Sigortalarından Mesleki Sorumluluk sigortalarına, Ferdi Kaza sigortalarından Finansal Sigortalara kadar çok geniş
              yelpazede, bireysel ve kurumsal müşterilerimizin ihtiyaçlarına uygun tüm poliçeler ile hizmetinizdeyiz.
            </p>
          </v-col>
        </div>
      </v-col>

      <v-col
        class="mb-5"
        cols="12"
      >
        <div class="grey d-flex flex-wrap justify-center lighten-1 py-16 mb-14">
          <v-card
            class="mx-5 my-3"
            max-width="280"
            min-height="500"
          >
            <v-img
              src="../assets/orman_araba.png"
              height="280px"
            ></v-img>

            <v-card-title class="font-weight-light">
              Kasko ve Trafik Sigortaları
            </v-card-title>

            <v-card-subtitle style="line-height: 2;" class="text-left black--text body-2 font-weight-light">
              Araçlarınızı ve üçüncü şahısları karşılaşabilecekleri  binbir riske karşı koruyan, mini onarım ve yardım hizmetleri ile hayatınızı kolaylaştıran sigortalar... 
            </v-card-subtitle>
          </v-card>
          <v-card
            class="mx-5 my-3"
            max-width="280"
            min-height="500"
          >
            <v-img
              src="../assets/sütünlar.png"
              height="280px"
            ></v-img>

            <v-card-title class="font-weight-light">
              Konut ve İşyeri Sigortaları
            </v-card-title>

            <v-card-subtitle style="line-height: 2;" class="text-left black--text body-2 font-weight-light">
              Hem varlıklarınızı her türlü riske karşı koruyacak hem de asistans hizmetleri ile hayatınızı kolaylaştıracak sigortalar...
            </v-card-subtitle>
          </v-card>
          <v-card
            class="mx-5 my-3"
            max-width="280"
            min-height="500"
          >
            <v-img
              src="../assets/yaprak.png"
              height="280px"
            ></v-img>

            <v-card-title class="font-weight-light">
              Sağlık Sigortaları
            </v-card-title>

            <v-card-subtitle style="line-height: 2;" class="text-left black--text body-2 font-weight-light">
              İsterseniz geniş kapsamlı Bireysel Sağlık ya da daha ekonomik olan Tamamlayıcı Sağlık, isterseniz yolculuklarınızın güvencesi Seyahat Sağlık...
            </v-card-subtitle>
          </v-card>
          <v-card
            class="mx-5 my-3"
            max-width="280"
            min-height="500"
          >
            <v-img
              src="../assets/bina_balkon.png"
              height="280px"
            ></v-img>

            <v-card-title class="font-weight-light">
              Mühendislik Sigortaları
            </v-card-title>

            <v-card-subtitle style="line-height: 2;" class="text-left black--text body-2 font-weight-light">
              İnşaat ve Montaj sigortalarından, Elektronik Cihaz sigortalarına kadar tüm riskleri kapsayan sigortalar...
            </v-card-subtitle>
          </v-card>
        </div>
      </v-col>
      
      <v-col cols="12" class="d-flex">
        <v-col cols="7" style="z-index: 9999;" class="mr-n16" >
          <v-row no-gutter align-content="center" class="mt-16">
            <div class="mt-16">
              <v-col cols="5" class="grey lighten-3 float-right pa-14">
                <h1 style="font-size:38px" class="font-weight-regular mb-6 float-left">
                  BİZ KİMİZ?
                </h1>
                <p style="font-size:14px; line-height: 2;" class="text-justify float-left mb-12">
                  1995 yılından bu yana, sektörün ileri gelen sigorta şirketleri aracılığı ve deneyimli ekibimizle, 
                  bireysel ve kurumsal sigortalılarımıza hizmet vermekteyiz.
                </p>
              </v-col>
            </div>
          </v-row>
        </v-col>
        <v-col cols="6" class="ml-n12 mb-16">
          <v-img
              class="shrink"
              src="../assets/ofis.png"
              transition="scale-transition"
              max-width="560"
            />
        </v-col>
      </v-col>

      <v-col cols="12" class="d-flex">
        <v-col cols="6">
          <v-col cols="6" class="d-flex flex-column float-right">
            <p style="font-size:38px" class="text-justify font-weight-regular float-left mb-6">
              BİZE ULAŞIN
            </p>
            <p style="font-size:14px ;line-height: 1.5;" class="text-justify float-left mb-8">
              Emek Mah. Barış Cad. Altılar Apt. No:5/B 01080 Seyhan Adana
            </p>
            <p style="font-size:14px;" class="text-justify float-left mb-8">
             tascisigorta1@gmail.com
            </p>
            <p style="font-size:14px;" class="text-justify float-left mb-2">
             0 (322) 436 55 21
            </p>
            <p style="font-size:14px;" class="text-justify float-left mb-2">
             0 (554) 748 55 85
            </p>
            <p style="font-size:14px;" class="text-justify float-left mb-8">
             0 (554) 748 54 63
            </p>
            <p style="font-size:14px;" class="text-justify float-left mb-2">
             Çalışma Saatleri:
            </p>
            <p style="font-size:14px;" class="text-justify float-left mb-2">
             Hafta içi: 09:00-18:00
            </p>
            <p style="font-size:14px;" class="text-justify float-left mb-2">
             Cumartesi: 09:00-13:00
            </p>
          </v-col>
        </v-col>
        <v-col cols="6" class="float-left">
          <v-col cols="6">
            <v-form v-model="valid">
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="firstname"
                      :rules="nameRules"
                      :counter="30"
                      label="Ad*"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      :counter="60"
                      label="E-posta*"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="phone"
                      label="Telefon"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="adres"
                      label="Adres"
                    ></v-text-field>
                  </v-col>
                   <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="konu"
                      label="Konu"
                    ></v-text-field>
                  </v-col>
                   <v-col
                    cols="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="mesaj"
                      label="Mesaj"
                    ></v-text-field>
                  </v-col>
                  <v-col 
                    cols="12"
                    md="12"
                  >
                    <v-btn
                      class="black mr-4 white--text"
                      type="submit"
                      :disabled="invalid"
                    >
                      Gönder
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-col>
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Home',

    data: () => ({
      valid: false,
      firstname: '',
      phone: '',
      adres: '',
      konu: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length <= 30 || 'Name must be less than 30 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
    })
  }
</script>
